/**
 * Converts a date to Central Time
 * @param {Date} date - The date to convert
 * @returns {Date} - The date in Central Time
 */
export const toCentralTime = (date) => {
    return new Date(date.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
};

/**
 * Formats a date string for display
 * @param {string} dateString - The date string to format (YYYY-MM-DD)
 * @returns {string} - Formatted date string (MM/DD/YYYY)
 */
export const formatDisplayDate = (dateString) => {
    if (!dateString) return "Select a day";
    
    // Convert string date to local date parts
    const [year, month, day] = dateString.split('-').map(num => parseInt(num, 10));
    // Create date in local timezone
    const date = new Date(year, month - 1, day);
    
    return date.toLocaleDateString('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
};

/**
 * Converts 24-hour time to 12-hour format
 * @param {string} time24 - Time in 24-hour format (HH:MM)
 * @returns {string} - Time in 12-hour format (HH:MM AM/PM)
 */
export const convertTo12HourFormat = (time24) => {
    if (!time24) return "";
    
    // Split the time into hours and minutes
    const [hours, minutes] = time24.split(':').map(Number);
    
    // Determine AM/PM
    const period = hours >= 12 ? 'PM' : 'AM';
    
    // Convert to 12-hour format
    const hours12 = hours % 12 || 12;
    
    // Format with leading zeros for minutes
    const formattedMinutes = minutes.toString().padStart(2, '0');
    
    return `${hours12}:${formattedMinutes} ${period}`;
};

/**
 * Formats time to 12-hour format
 * @param {string} time - The time to format (can be in 12-hour or 24-hour format)
 * @returns {string} - Formatted time string in 12-hour format
 */
export const formatTimeDisplay = (time) => {
    if (!time) return "Select a time";
    
    // Check if time is already in 12-hour format (contains AM/PM)
    if (time.includes('AM') || time.includes('PM')) {
        return time;
    }
    
    // If time is in 24-hour format, convert it
    return convertTo12HourFormat(time);
};

/**
 * Returns a formatted month and year string
 * @param {Date} date - The date to format
 * @returns {string} - Formatted month and year (e.g., "January 2024")
 */
export const getFormattedMonthYear = (date) => {
    return date.toLocaleDateString('en-US', { 
        month: 'long', 
        year: 'numeric',
        timeZone: 'America/Chicago'
    });
};

/**
 * Default time slots for scheduling
 */
export const DEFAULT_TIME_SLOTS = [
    "8:00 AM", "8:30 AM","9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM", 
    "11:00 AM", "11:30 AM","12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", 
    "2:00 PM", "2:30 PM", "3:00 PM", "3:30 PM", "4:00 PM", "4:30 PM", 
    "5:00 PM", "5:30 PM", "6:00 PM", "6:30 PM", "7:00 PM", "7:30 PM"
];
